import Vue from 'vue'
import DynamicSearch from './index.vue'

Vue.component('DynamicSearch', DynamicSearch)



// WEBPACK FOOTER //
// ./src/components/DynamicSearch/search.js